import React from 'react';

import { Menu } from '@mui/material';
import { CheckMarkMenuItem } from 'src/components';
import { Apollo } from 'src/gql/generated';

export const docAccessLevelDisplayMap = Object.assign(
  {},
  {
    [Apollo.PermissionRole.Viewer]: 'Viewer',
    [Apollo.PermissionRole.Commenter]: 'Commenter',
    [Apollo.PermissionRole.Suggester]: 'Suggester',
    [Apollo.PermissionRole.Editor]: 'Editor',
  },
  {
    [Apollo.DocAccessLevel.NoAccess]: 'No Access',
    [Apollo.DocAccessLevel.Viewer]: 'Viewer',
    [Apollo.DocAccessLevel.Commenter]: 'Commenter',
    [Apollo.DocAccessLevel.Suggester]: 'Suggester',
    [Apollo.DocAccessLevel.Editor]: 'Editor',
    [Apollo.DocAccessLevel.Owner]: 'Owner',
    [Apollo.DocAccessLevel.Custom]: 'Custom',
  }
);

export function accessLevelToPermissionRole(
  accessLevel: Exclude<
    Apollo.DocAccessLevel,
    Apollo.DocAccessLevel.Owner | Apollo.DocAccessLevel.NoAccess | Apollo.DocAccessLevel.Custom
  >
): Apollo.PermissionRole {
  switch (accessLevel) {
    case Apollo.DocAccessLevel.Editor:
      return Apollo.PermissionRole.Editor;
    case Apollo.DocAccessLevel.Suggester:
      return Apollo.PermissionRole.Suggester;
    case Apollo.DocAccessLevel.Commenter:
      return Apollo.PermissionRole.Commenter;
    case Apollo.DocAccessLevel.Viewer:
      return Apollo.PermissionRole.Viewer;
  }
}

interface WorkflowDocAccessMenuProps {
  anchorEl: HTMLElement | null;
  handleSelect: (permissionRole: Apollo.PermissionRole) => void;
  onClose: () => void;
  open: boolean;
  value: Apollo.DocAccessLevel | null;
  className?: string;
  disabled?: boolean;
}

const permissionRoleAccessLevels = [
  Apollo.DocAccessLevel.Editor,
  Apollo.DocAccessLevel.Suggester,
  Apollo.DocAccessLevel.Commenter,
  Apollo.DocAccessLevel.Viewer,
] as const;

export function WorkflowDocAccessMenu({
  anchorEl,
  className,
  disabled,
  handleSelect,
  onClose,
  open,
  value,
}: WorkflowDocAccessMenuProps): JSX.Element | null {
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className={className}
      open={open}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={onClose}
    >
      {permissionRoleAccessLevels.map((accessLevel, index) => (
        <CheckMarkMenuItem
          key={index}
          disabled={disabled}
          selected={value === accessLevel}
          value={accessLevel}
          onClick={() => {
            onClose();
            handleSelect(accessLevelToPermissionRole(accessLevel));
          }}
        >
          {docAccessLevelDisplayMap[accessLevel]}
        </CheckMarkMenuItem>
      ))}
    </Menu>
  );
}
